module.exports = __webpack_public_path__ + "static/media/diktat-36.00c7e72a.mp3";